<template>
  <div>
    <div style="padding: 3px"> 
        <a v-if="hasSubTab" @click="toggle()" href="#">
            <i v-bind:class="isOpen ? 'fa fa-caret-down fa-lg fg-fw' : 'fa fa-caret-right fa-lg fg-fw'" aria-hidden="true"></i>
        </a>
        <span v-else style="margin-left:11px"></span>

        <span @click="toggle()" class="tab-item" v-bind:class="isSelected ? 'tab-highlight': ''" > 
            {{ item.Name + (item.Mode ? ` (${modeNames[item.Mode]})` : '') }} 
        </span>

        <a v-if="isEditable" href="#" class="tab-set" data-toggle="dropdown" title='Edit tab'>
            <i class="fa fa-cog" aria-hidden="true"></i>
        </a>
        <ul class="dropdown-menu tab-options">
            <li><a href="#" @click="popup(item, 'edit')">Edit current tab</a></li>
            <div class="dropdown-divider"></div>
            <li><a href="#" @click="popup(item, 'insertabove')">Insert tab above</a></li>
            <li><a href="#" @click="popup(item, 'insertbelow')">Insert tab below</a></li>
            <div class="dropdown-divider"></div>
            <li v-if="!hasSubTab"><a href="#" @click="popup(item, 'addchild')">Create sub-tab</a></li>
        </ul>

        <a v-if="!hasSubTab" href="#" class="tab-set ml-1" @click="$emit('toggle-item', item)" title='Edit content'>
            <i class="fa fa-pencil" aria-hidden="true"></i>
        </a>

        <b-modal ref="tab-edit-modal" centered hide-footer :title="modalTitle">
            <div>
                <div class="form-group" v-if="!tab.id || action === 'edit'">
                    <label class="form-label">Tab Name</label>
                    <input type="text" class="form-control form-control-sm" v-model="tab.name">
                </div>
            </div>
            <div>
                <div class="btn-group" >
                    <button class="btn btn-dark btn-sm" style="margin-bottom:0px" @click="save"><i class="fa fa-save"></i> Save</button>
                    <button class="btn btn-secondary btn-sm" style="margin-bottom:0px" @click="cancel"><i class="fa fa-remove"></i> Cancel</button>
                </div>
                <button v-if="action === 'edit'" class="btn btn-danger btn-sm" style="float:right;margin-bottom:0px" @click="del"><i class="fa fa-trash"></i> Delete</button>
            </div>
        </b-modal>
    </div>

    <div v-show="isOpen" v-if="hasSubTab" class="ml-3">
        <tab-tree-view v-for="(child, i) in item.Children" :key="i" :item="child" :selected="selected" :allowEdit="allowEdit" :all="all" 
            @toggle-item="$emit('toggle-item', $event)" 
            @modify-item="$emit('modify-item', $event)">
        </tab-tree-view>
    </div>
  </div>
</template>

<style>
.or {
    border-top: 2px dashed #aaa;
    text-align: center;
}

.or::after {
    background: #fff;
    content: 'OR';
    color: gray;
    padding: 0 4px;
    position: relative;
    top: -13px;
}

.tab-item {
    padding:5px;
    cursor: default;
    font-family: Arial, Helvetica, sans-serif;
}

.tab-item:hover {
    background-color: lightgrey;
}

.tab-set {
    color:darkgrey;
}

.tab-set:hover {
    color:black;
}

.tab-options a {
    cursor: default;
    color: black;
    padding-left:15px;
    font-size:0.85em
}

.tab-options a:hover {
    text-decoration: none;
    color: black;
}

.tab-options li:hover {
    background-color: whitesmoke;
}

.tab-highlight {
    background-color: slategray;
    font-weight: bolder;
    color:white; 
}
</style>

<script>
export default {
    name: 'tab-tree-view',
    props: {
        item: Object,
        selected: Object,
        allowEdit: Boolean, 
        all: Array
    },
    data: function () {
        return {
            isOpen: this.item.Id === null,
            currentItem: {},
            tab: {
                id: null,
                name: null,
                mode: null
            },
            action: null,
            modalTitle: null,
            modeNames: {
                '84afb7d0-b21e-458d-b583-b8ace97baa7b': 'USG',
                '473dddc6-cab4-4fb7-bb5d-74ba4a03d610': 'Local'
            }
        }
    },
    computed: {
        hasSubTab: function () {
            return this.item.Children && this.item.Children.length;
        },
        isSelected: function() {
            return this.selected.Id === this.item.Id;
        },
        isEditable: function() {
            return this.allowEdit && this.item.Id && this.item.Id !== '2cc327ac-82a9-440c-ba3e-19a463e43db4';
        }
    },
    methods: {
        toggle: function() {
            if (this.hasSubTab) {
                this.isOpen = !this.isOpen
            }
        },
        popup: function(item, act) {
            this.action = act;
            this.tab = act === 'edit' 
                ? { id: item.Id, name: item.Name, mode: item.Mode } 
                : { id: null, name: null, mode: null };
                
            this.currentItem = item;

            if (act === 'edit'){
                this.modalTitle = 'Edit tab - ' + item.Name;
            } else if (act === 'insertabove'){
                this.modalTitle = 'Insert tab above ' + item.Name;
            } else if(act === 'insertbelow'){
                this.modalTitle = 'Insert tab below ' + item.Name;
            } else if(act === 'addchild'){
                this.modalTitle = 'Add sub-tab in ' + item.Name;
            }
            
            this.$refs['tab-edit-modal'].show();
        },
        save: function() {
            if (!this.tab.id && !this.tab.name) {
                return;
            }

            var params = {
                model: this.currentItem, 
                action: this.action, 
                tab: this.tab
            };

            this.$emit("modify-item", params);
            
            this.cancel();
        },
        cancel: function() {
            this.$refs['tab-edit-modal'].hide();
        },
        del: function() {
            this.action = 'delete';
            this.$emit("modify-item", {
                model: this.currentItem, 
                action: this.action
            });

            this.cancel();
        }   
    }
}
</script>